module.exports = __webpack_public_path__ + "static/media/CV-JoseAlfredoTorres.35b57f3d.pdf";